module.exports = __webpack_public_path__ + "img/vr.17e5f8b2.png";